module.exports = "/assets/220f335aa548073082beb048fab18ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HA.png
// module id = 1433
// module chunks = 0